import script from "./ForumLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumLayout.vue?vue&type=script&setup=true&lang=js"

import "./ForumLayout.vue?vue&type=style&index=0&id=d45ec8b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d45ec8b2"]])

export default __exports__